<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <!-- <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Transportation Reports</b-navbar-brand>

         
        </b-navbar> -->
        <md-tabs>
          <md-tab md-icon="home" md-label="Dashboard">
            <div class="row mt-2">
              <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Clients</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers Executed
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsRefuel"
                        :series="seriesRefuel"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Place of Receipt</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers (Import)
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsExDesti"
                        :series="seriesExDesti"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Shipping Line</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers Shipped
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsShip"
                        :series="seriesShip"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Imported Commodities</h4>

                    <div class="d-flex mt-3 py-2 border-bottom" v-for="(item1, index) in topcommodity" :key="index">

                      <div>
                        <p class="mb-n1 font-weight-semibold">
                          {{ item1.itemDescription }}
                        </p>

                      </div>
                      <small class="text-muted ml-auto">Exported {{ item1.commodityCount }} Times </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </md-tab>

          <md-tab md-icon="content_paste" md-label="CC Import Reports">
            <div class="mt-3">
              <div>
                <b-button variant="outline-dark" :class="visible ? null : 'collapsed'"
                  :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4" @click="visible = !visible">
                  Filters</b-button>

                <b-button class="pull-right" v-if="importData.length>0" @click="getReports('CC_Import')" size="sm"
                  variant="warning">Export as Excel</b-button>

              </div>


              <b-collapse v-model="visible" id="collapse-2">
                <b-card class="gutr">
                  <md-layout md-gutter>
                    <md-layout md-flex="30" md-flex-small="100">
                      <model-list-select :list="clientMaster" id="clientNamenew" v-model="clientIdFilter"
                        option-value="clientId" option-text="clientName" placeholder="Select  Client Name">
                      </model-list-select>
                    </md-layout>


                    <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20" md-flex-small="100">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                  ></model-list-select>
                </md-layout> -->
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" md-flex-small="100">
                      <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                        @update="viewAssignment('0', '1', '1');">
                        <!--Optional scope for the input displaying the dates -->
                        <!-- <div slot="input" slot-scope="picker">{{ picker.startDate }} - {{ picker.endDate }}</div> -->
                      </date-range-picker>
                    </md-layout>
                  </md-layout>

                  <div class="mt-3">
                    <b-button size="sm" class="pull-right" @click="filterSearch" variant="outline-primary">Search
                    </b-button>
                    <b-button style="margin-right:5px" size="sm" class="pull-right" @click="clearFilter"
                      variant="outline-info">clear</b-button>
                  </div>
                </b-card>
              </b-collapse>
            </div>

            <div class="mt-3">

              <h5 class="text-muted pull-right mt-2 ml-3">
                <small>{{totalRows}} Entries</small>
              </h5>
            </div>



            <div class="table-responsive tableMain">
              <b-table show-empty stacked="md" :items="importData" :fields="fields" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                <template slot="seenExec" slot-scope="row0">
                  <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>
                <template slot="ccImportSeries" slot-scope="row1">
                  <b>{{row1.item.ccImportSeries}}</b>
                  <br>
                  <span>Assignment Date : {{row1.item.dateAssignment | moment}}</span>

                  <br>
                  <span>Raised From : {{row1.item.EmpLoc}}</span>
                </template>
                <template slot="ContainerNo" slot-scope="row5">
                  <div v-if="row5.item.ContainerNo!=null">
                    <div v-if="row5.item.ContainerNo!=null">
                      <span v-for="(item1,index) in row5.item.ContainerNo.split(',')" :key="index">
                        <h6>
                          <b-badge variant="light">{{item1==''?'-------':item1}}</b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <b-badge variant="light">-------</b-badge>
                  </div>
                </template>

              </b-table>
            </div>
            <div>
              <b-pagination align="center" limit="25" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
            </div>
          </md-tab>




        </md-tabs>

      </b-card-text>
    </b-card>
  </div>
</template>


<script>
  import axios from "axios";
  import moment from "moment";
  import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
  import CustomLoader from "../common/customLoader.vue";
  import DateRangePicker from "vue2-daterange-picker";
  import "vue-loading-overlay/dist/vue-loading.css";
  import DatePicker from "vue2-datepicker";
  import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
  import { globalPermissionStatus } from "../../helper/collection";

  export default {
    beforeMount() {

      if (globalPermissionStatus("Custom Clearance")) {
        this.$store.dispatch("setCurrentRoute", "/reports/ccReports");

        this.viewAssignment("0", "1", "1");
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
    },
    data() {
      return {

        seriesExDesti: [
          {
            name: "No. of Containers",
            data: [],
          },
        ],
        chartOptionsExDesti: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers",
            },
          },
          fill: {
            type: "",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 1,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },
        seriesRefuel: [
          {
            name: "No. of Containers Executed",
            data: [],
          },
        ],
        chartOptionsRefuel: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers Executed",
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },
        showGraph: false,
        fieldsV: [
          {
            key: "vehicleTruckId",
            label: "Sr No.",
            sortable: true,
            sortDirection: "desc"
          },
          {
            key: "regdNo",
            label: "Vehicle No.",
            sortable: true,
            sortDirection: "desc"
          },

          {
            key: "noOfTripscount",
            label: " No. Of Trips",
            sortable: true,
            sortDirection: "desc"
          },



          {
            key: "sumDieselUsed",
            label: " Diesel Consumed (Ltr's)",
            sortable: true,
            sortDirection: "desc"
          }

        ],
        totalVehicleCount: "",
        availVehicleCount: "",
        bookVehicleCount: "",
        currentPageV: 1,
        perPageV: 10,
        totalRowsV: "",
        pageOptionsV: [5, 10, 15],
        sortByV: null,
        sortDescV: false,
        sortDirectionV: "desc",
        filterV: null,
        modalInfo: { title: "", content: "" },
        clientMaster: [],
        topTPTClientRevenue: [],
        importData: [],
        topcommodity: [],
        seriesShip: [
          {
            name: "No. of Containers Shipped",
            data: [],
          },
        ],
        chartOptionsShip: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers Shipped",
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },

        vehicleReports: [],
        clientIdFilter: "",
        transportTypeFilter: "",
        transportTypeName: [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export"
          },
          {
            transportTypeVal: "Import",
            transportTypeText: "Import"
          }
        ],
        reload: true,

        visible: false,

        startDate: "2017-09-05",
        endDate: "2017-09-15",
        openLeft: "left",
        showCal: false,
        dateRange: {},
        locale: {
          direction: "ltr",
          format: "mm/dd/yyyy",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          firstDay: 0
        },
        totalRows: 1,
        currentPage: 2,
        perPage: 10,
        pageOptions: [20, 50, 100],
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        fields: [
          {
            key: "seenExec",
            mainkey: "seenExec",
            label: "Sr No.",
            sortable: true,
            sortDirection: "ASC"
          },
          {
            key: "ccImportSeries",
            mainkey: "ccImportSeries",
            label: "Assignment No.",
            sortable: true,
            sortDirection: "ASC",
            table: "A."
          },
          {
            key: "Importer",
            mainkey: "clientName",
            label: "Client / Importer Name",
            sortable: true,
            sortDirection: "ASC",
            table: "B."
          },
          {
            key: "Exporter",
            mainkey: "clientName",
            label: " Exporter Name",
            sortable: true,
            sortDirection: "ASC",
            table: "C."
          },

          {
            key: "ContainerNo",
            mainkey: "ContainerNo",
            label: "Container No.",
            sortable: true,
            sortDirection: "ASC",
            table: "A."
          },
          // {
          //   key: "containerTypeName",
          //   mainkey: "containerTypeName",
          //   label: "Container Type",
          //   sortable: true,
          //   sortDirection: "ASC",
          //   table: "A."
          // },

          {
            key: "placeRecp",
            mainkey: "pickupLocation",
            label: "Place of Receipt",
            sortable: true,
            sortDirection: "ASC",
            table: "D."
          },
          {
            key: "LoadPort",
            mainkey: "pickupLocation",
            label: "Load Port",
            sortable: true,
            sortDirection: "ASC",
            table: "I."
          },
          {
            key: "placeDis",
            mainkey: "pickupLocation",
            label: "Port of Discharge",
            sortable: true,
            sortDirection: "ASC",
            table: "E."
          },
          {
            key: "finalPlace",
            mainkey: "pickupLocation",
            label: "Final Place of Delivery",
            sortable: true,
            sortDirection: "ASC",
            table: "H."
          },


        ],
        NoOfAssignment: "",
        isLoading: false,
        viewAssignment1: [],

      };
    },

    filters: {
      moment(date) {
        return DateFormat(date)
      }
    },

    mounted() { },
    beforeDestroy() { },
    destroyed() { },
    components: {
      ModelListSelect,
      // Loading,
      CustomLoader,
      DateRangePicker
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fieldsV
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
      }
    },

    methods: {
      onFilteredV(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsV = filteredItems.length;
        this.currentPageV = 1;
      },
      filterSearch() {
        this.reload = false;
        this.viewAssignment("0", "1", "1");
      },
      clearFilter() {

        this.clientIdFilter = "";
        this.transportTypeFilter = "";
        this.dateRange = ""
        this.viewAssignment("0", "1", "1");
      },
      getReports(id) {

        let view_Assignment = {
          excelId: 'CC_Import',
          dateRange: this.dateRange,
          clientIdFilter: this.clientIdFilter,
          transportTypeFilter: this.transportTypeFilter,

        };
        console.log(view_Assignment);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
          data: JSON.stringify(view_Assignment),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {

              if (data.excelName != undefined) (


                window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName
              )

              //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

              // console.log(abc)



            }
          })
          .catch(error => { });


      },

      onPageChange: function (event) {
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = event * this.perPage - this.perPage;
        }

        this.viewAssignment(CURRENT, "2", event);

        // let totalRows = 1064 / this.perPage;
        // if(this.totalRow )
      },
      viewVBookingPage(
        clientId,
        salesid,
        quotationId,
        assignId,
        vBookingId,
        followUpId
      ) {
        this.$sessionsStorage.set("clientId", clientId);
        this.$sessionsStorage.set("salesBookingId", salesid);
        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$sessionsStorage.set("storeAssignId", assignId);
        this.$sessionsStorage.set("storeVehicleBookingId", vBookingId);
        if (followUpId == "" || followUpId == null) {
          this.$sessionsStorage.set("storefollowActivityId", "false");
        } else {
          this.$sessionsStorage.set("storefollowActivityId", followUpId);
        }

        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      },
      goToTrack(AId) {
        this.$sessionsStorage.set("storeAssignId", AId);
        this.$sessionsStorage.set("backToDetailPage", "22");
        this.$router.push({
          path: "/vehicleQuotation/tranportMailDetails"
        });
      },
      goToMain() {
        this.$router.push({
          path: "/sales/salesBooking"
        });
      },
      doLoading() {
        this.isLoading = true;
      },
      doLoadingClose() {
        this.isLoading = true;

        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },

      JqueryFun() {
        return $(function () {
          return $("#viewVehicleBooking21212").DataTable();
        });
      },

      viewAssignmentpage(clientId, salesid, quotationId, assignId) {
        this.$sessionsStorage.set("storeAssignId", assignId);
        this.$sessionsStorage.set("clientId", clientId);
        this.$sessionsStorage.set("salesBookingId", salesid);
        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      },

      viewAssignment(CURRENT, SEARCH, pageNumber) {
        this.isLoading = true;

        let view_Assignment = {
          searchVal: this.filter,
          fields: this.fields,
          fromSearch: SEARCH,

          currentPage: CURRENT,

          perPage: this.perPage,

          assignmentNo: "assignmentNo",
          dateRange: this.dateRange,
          clientIdFilter: this.clientIdFilter,
          transportTypeFilter: this.transportTypeFilter,
        };
        console.log(view_Assignment);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Reports/getCCImportReports.php`,
          data: JSON.stringify(view_Assignment),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              console.log(data);
              this.importData = []
              this.topcommodity = []

              if (SEARCH != "2") {
                this.currentPage = 1;
                this.totalRows = data.totalData;
              } else {
                this.currentPage = pageNumber;
              }

              if (data.importData.length > 0) {
                this.importData = data.importData;

              }
              if (data.topcommodity.length > 0) {
                this.topcommodity = data.topcommodity;
              }
              if (data.topSline.length > 0) {

                this.chartOptionsShip.xaxis.categories = [];
                this.seriesShip[0].data = [];

                for (let m = 0; m < data.topSline.length; m++) {
                  this.chartOptionsShip.xaxis.categories.push(
                    data.topSline[m].shippingLine
                  );

                  this.seriesShip[0].data.push(
                    data.topSline[m].totalClientContainerFFExport
                  );
                }
              }
              if (this.reload == true) {

                if (data.clientMaster.length > 0) {
                  this.clientMaster = data.clientMaster;
                }

              }
              if (data.topClientByContainer.length > 0) {
                this.chartOptionsRefuel.xaxis.categories = [];
                this.seriesRefuel[0].data = [];

                for (let q = 0; q < data.topClientByContainer.length; q++) {
                  this.chartOptionsRefuel.xaxis.categories.push(
                    data.topClientByContainer[q].clientName
                  );

                  this.seriesRefuel[0].data.push(
                    data.topClientByContainer[q].totalClientContainerFFExport
                  );
                }
              }
              if (data.topExportDestination.length > 0) {

                this.chartOptionsExDesti.xaxis.categories = [];
                this.seriesExDesti[0].data = [];

                for (let m = 0; m < data.topExportDestination.length; m++) {
                  this.chartOptionsExDesti.xaxis.categories.push(
                    data.topExportDestination[m].pickupLocation
                  );

                  this.seriesExDesti[0].data.push(
                    data.topExportDestination[m].totalClientContainerFFExport
                  );
                }

              }

              this.showGraph = true;

              this.isLoading = false;
            }
          })
          .catch(error => { });
      }
    }
  };
</script>
<style>
.md-theme-default.md-tabs>.md-tabs-navigation {
    background-color: #ffffff;
}
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header{
  color: #6e6b79;
}
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header.md-active, .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header:focus {
  color: #6e6b79;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-indicator {
  background-color: #002b48; 
  height: 4px;
  border-radius: 10px;
}
.md-whiteframe {
  background: #fff;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.423rem
}
</style>


// WEBPACK FOOTER //
// ccImportReports.vue?a3ea4866